var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.643 2v12h10.715V2H2.642Zm2.143 8h6.428c.592 0 1.072.447 1.072 1 0 .553-.48 1-1.072 1H4.786c-.592 0-1.072-.447-1.072-1 0-.553.48-1 1.072-1Zm6.428-3H4.786c-.592 0-1.072.447-1.072 1 0 .553.48 1 1.072 1h6.428c.592 0 1.072-.447 1.072-1 0-.553-.48-1-1.072-1ZM9.071 6H4.786c-.592 0-1.072-.447-1.072-1 0-.553.48-1 1.072-1H9.07c.592 0 1.072.447 1.072 1 0 .553-.48 1-1.072 1Zm4.286-6H2.643C1.46 0 .5.897.5 2v12c0 1.103.961 2 2.143 2h10.714c1.182 0 2.143-.897 2.143-2V2c0-1.103-.961-2-2.143-2Z",
    clipRule: "evenodd"
  })));
};
export default SvgDocument;